import { getISODate } from "../getISODate";
export var mapStartDateTime = function (event, config) {
    var date = config.hasSettlementDate && event.metadata.settlementDate ?
        event.metadata.settlementDate : event.startEventDate;
    var eventDate = getISODate(date, config.currentTimeZone);
    event.eventDate = eventDate ? eventDate.formatDate(config.dateFormat) : "--";
    event.eventTime = eventDate ? eventDate.formatDate(config.timeFormat) : "--";
    return event;
};
//# sourceMappingURL=mapStartDateTime.js.map